import React from 'react';
import { IndexRoute, Route } from 'react-router';
import SignupCompany from './signupCompany';

export default (
  <Route path="signup-company">
    <IndexRoute component={props => <SignupCompany {...props} />} />
  </Route>
);
